import React from 'react';
import { Award, Heart, Users, Microscope } from 'lucide-react';
import { clinicInfo, heroImages } from '../mockData';

const AboutSection = () => {
  const features = [
    {
      icon: Award,
      title: 'Equipe experiente',
      description: `Mais de ${clinicInfo.experience} cuidando de sorrisos em Paranaguá — você pode confiar`,
    },
    {
      icon: Heart,
      title: 'Atendimento de verdade',
      description: 'A gente trata você pelo nome, com respeito e sem pressa na consulta',
    },
    {
      icon: Microscope,
      title: 'Equipamentos modernos',
      description: 'Tecnologia de ponta para você ter um diagnóstico claro e tratamento seguro',
    },
    {
      icon: Users,
      title: 'Mais de 1.000 pacientes',
      description: 'Famílias de Paranaguá e região que já confiaram o sorriso na gente',
    },
  ];

  return (
    <section id="sobre" className="bg-white py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-20 max-w-3xl text-center">
          <p className="mb-3 text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-brand-steel">
            Nossa história
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-brand-ink md:text-5xl">
            Sobre a <span className="text-brand-deep">Ortodontia Líder</span>
          </h2>
          <p className="mt-6 text-lg font-light leading-relaxed text-brand-muted">
            Há mais de <strong className="font-semibold text-brand-ink">{clinicInfo.experience}</strong> em Paranaguá,
            cuidando de aparelhos, implantes e tratamentos para toda a família. A gente explica tudo
            com clareza, não faz nada sem sua autorização e parcela do jeito que{' '}
            <strong className="font-semibold text-brand-ink">cabe no seu bolso</strong>.
          </p>
        </div>

        <div className="mb-20 grid items-center gap-14 md:grid-cols-2">
          <div className="relative">
            <div className="absolute -left-3 top-8 hidden h-32 w-32 rounded-full bg-brand-gold/15 blur-2xl md:block" aria-hidden />
            <img
              src={heroImages.consultation}
              alt="Dr. Leandro - Ortodontia Líder"
              className="relative z-10 h-[420px] w-full rounded-[1.5rem] object-cover shadow-brand-lg ring-1 ring-brand-ink/5"
            />
            <div className="absolute -bottom-5 -right-2 z-20 rounded-2xl bg-brand-deep px-8 py-5 text-white shadow-brand-lg">
              <div className="font-display text-4xl font-semibold">{clinicInfo.experience}</div>
              <div className="text-sm font-medium text-white/85">de dedicação</div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="font-display text-3xl font-semibold text-brand-ink md:text-4xl">
              Uma clínica séria, perto de você
            </h3>
            <p className="leading-relaxed text-brand-muted">
              Cada pessoa é diferente — por isso montamos um plano só para o seu caso. Antes de
              começar qualquer tratamento, a gente senta com você, explica as opções e tira todas as
              dúvidas.
            </p>
            <p className="leading-relaxed text-brand-muted">
              Se você tem medo de dentista ou de gastar demais, fique tranquilo: nosso atendimento é
              acolhedor, sem dor desnecessária e com parcelamento facilitado.
            </p>
            <div className="rounded-2xl border border-brand-ink/8 bg-brand-cream/80 p-6">
              <p className="font-display text-lg italic leading-relaxed text-brand-ink">
                &ldquo;Nosso compromisso é simples: cuidar do seu sorriso com carinho, honestidade e
                resultado que você possa ver no espelho.&rdquo;
              </p>
            </div>
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className="group rounded-2xl border border-brand-ink/8 bg-gradient-to-b from-white to-brand-wash/40 p-6 shadow-sm transition hover:-translate-y-0.5 hover:border-brand-deep/15 hover:shadow-brand-lg"
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-deep text-white shadow-inner-soft ring-1 ring-white/10 transition group-hover:bg-brand-ink">
                  <Icon className="h-6 w-6" strokeWidth={1.75} />
                </div>
                <h4 className="mb-2 font-display text-xl font-semibold text-brand-ink">{feature.title}</h4>
                <p className="text-sm leading-relaxed text-brand-muted">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
